import { render, staticRenderFns } from "./PhoneVerificationForm.vue?vue&type=template&id=1db96cef&"
import script from "./PhoneVerificationForm.vue?vue&type=script&lang=js&"
export * from "./PhoneVerificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports